import { ServiceActiveStatus, ServiceInactiveStatus } from '@kaa/api/providers';
import { Icon } from '../icon/SwIcon.constants';

export enum AlertType {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  INFORMATION = 'INFORMATION',
}

export const getAlertPropsByType = (type?: AlertType) => {
  switch (type) {
    case AlertType.SUCCESS:
      return {
        icon: Icon.CHECK_CIRCLE,
        modSuccess: true,
      };
    case AlertType.WARNING:
      return {
        icon: Icon.ALERT_CIRCLE,
        modWarning: true,
      };
    case AlertType.ERROR:
      return {
        icon: Icon.ALERT_CIRCLE,
        modError: true,
      };
    case AlertType.INFORMATION:
      return {
        icon: Icon.INFO_CIRCLE,
        modInfo: true,
      };
    default:
      return {
        icon: Icon.CHECK_CIRCLE,
      };
  }
};

export const getAlertTypeByServiceStatus = (
  status: ServiceActiveStatus | ServiceInactiveStatus,
): AlertType | undefined => {
  switch (status) {
    case ServiceActiveStatus.PAID:
    case ServiceInactiveStatus.REFUND_REQUESTED:
      return AlertType.SUCCESS;

    case ServiceActiveStatus.MODIFIED:
    case ServiceActiveStatus.CORRECTED:
    case ServiceActiveStatus.CONFIRMED:
    case ServiceActiveStatus.MISSING_VOUCHERS:
    case ServiceActiveStatus.MISSING_CONTRACT:
    case ServiceActiveStatus.PARTIALLY_ASSIGNED_TO_BE_PAID_OUTSIDE_SV:
    case ServiceActiveStatus.PARTIALLY_REFUNDED:
    case ServiceInactiveStatus.PARTIALLY_REFUNDED_TO_BE_PAID_OUTSIDE_SV:
    case ServiceInactiveStatus.TO_BE_PAID_OUTSIDE_SV:
      return AlertType.WARNING;

    case ServiceActiveStatus.PARTIALLY_ASSIGNED:
    case ServiceActiveStatus.CREATED:
    case ServiceActiveStatus.VALIDATED:
    case ServiceActiveStatus.READY_FOR_VOUCHER_ASSIGNMENT:
      return AlertType.INFORMATION;

    case ServiceActiveStatus.PROPOSITION_TO_CANCEL:
    case ServiceActiveStatus.CONTESTED:
    case ServiceInactiveStatus.CANCELED:
      return AlertType.ERROR;

    default:
      return null;
  }
};
